import BusyOverlay from '../components/shared/BusyOverlay.vue'
import BaseModal from '../components/shared/modal/BaseModal.vue'
import BaseDropdown from '../components/shared/dropdown/BaseDropdown.vue'
import BaseDropdownItem from '../components/shared/dropdown/BaseDropdownItem.vue'
import BaseDropdownDivider from '../components/shared/dropdown/BaseDropdownDivider.vue'
import BasePagination from '../components/shared/BasePagination.vue'
import BaseCollapse from '../components/shared/BaseCollapse.vue'
import FormGroup from '../components/shared/form/FormGroup.vue'
import FormCheckbox from '../components/shared/form/FormCheckbox.vue'
import FormRadio from '../components/shared/form/FormRadio.vue'
import FormRadioGroup from '../components/shared/form/FormRadioGroup.vue'
import collapseToggle from '../directives/collapseToggle'
import tooltip from '../directives/tooltip'

// bootstrap-vue'nun yerine geçen ortak ilkel bileşenler (Aşama 2.1) ve form sarmalayıcıları (2.3). BS4 işaretlemesi üretir,
// Bootstrap JS kullanmaz. Yeni kodda bootstrap-vue karşılıkları yerine bunlar kullanılır.
export default {
  install(app) {
    app.component('BusyOverlay', BusyOverlay)
    app.component('BaseModal', BaseModal)
    app.component('BaseDropdown', BaseDropdown)
    app.component('BaseDropdownItem', BaseDropdownItem)
    app.component('BaseDropdownDivider', BaseDropdownDivider)
    app.component('BasePagination', BasePagination)
    app.component('BaseCollapse', BaseCollapse)
    app.component('FormGroup', FormGroup)
    app.component('FormCheckbox', FormCheckbox)
    app.component('FormRadio', FormRadio)
    app.component('FormRadioGroup', FormRadioGroup)
    app.directive('collapse-toggle', collapseToggle)
    app.directive('tooltip', tooltip)
  }
}
